import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapHeaderControlsService {
  private _buildingMenuOpen$ = new Subject();
  private _userProfileMenuOpen$ = new Subject();
  private _cogMenuOpen$ = new Subject();
  private _electricityCostMenuOpen$ = new Subject();
  private _contactMenuOpen$ = new Subject();

  public get buildingMenuOpen() {
    return this._buildingMenuOpen$.asObservable();
  }

  public get _contactMenuOpen() {
    return this._contactMenuOpen$.asObservable();
  }

  public get userProfileMenuOpen() {
    return this._userProfileMenuOpen$.asObservable();
  }

  public get cogMenuOpen() {
    return this._cogMenuOpen$.asObservable();
  }

  public get electricityCostMenuOpen() {
    return this._electricityCostMenuOpen$.asObservable();
  }

  openBuildingMenu() {
    this._buildingMenuOpen$.next(true);
  }

  openContactMenu() {
    this._contactMenuOpen$.next(true);
  }

  openUserProfileMenu() {
    this._userProfileMenuOpen$.next(true);
  }

  openCogMenu() {
    this._cogMenuOpen$.next(true);
  }

  openElectricityCostMenu() {
    this._electricityCostMenuOpen$.next(true);
  }

  closeAll() {
    this._buildingMenuOpen$.next(false);
    this._userProfileMenuOpen$.next(false);
    this._cogMenuOpen$.next(false);
    this._electricityCostMenuOpen$.next(false);
    this._contactMenuOpen$.next(false);
  }
}
